import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { saveAs } from "file-saver";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { splitFileName, fileType, getDateFormat } from "utils/helper";
import VideoPlayer from "../VideoPlayer";
import VideoMedia from "./VideoMedia";
import close from "assets/images/close.svg";
import removebg from "assets/images/removebg.svg";
import { updateImage } from "service/Inventory";
import "swiper/swiper-bundle.css";

import styles from "./ProductMedia.module.scss";
import {
  RemoveBgResult,
  RemoveBgError,
  removeBackgroundFromImageUrl,
} from "remove.bg";
import { Toast } from "utils/toast";

SwiperCore.use([Navigation]);

const ProductMedia = ({
  isOpen,
  toggle,
  url,
  onAdd,
  onDelete,
  onEdit,
  showAction = true,
  data,
  handleRefresh,
}) => {
  let [activeIndex, setActiveIndex] = useState(0);
  const apikey = "oWMn7XZimqhCFQfptWtZWgwR";
  const imageSwiper = {
    slidesPerView: 4,
    direction: "vertical",
    navigation: {
      nextEl: "#nextMedia",
      prevEl: "#prevMedia",
    },
    loop: false,
    spaceBetween: 0,
    initialSlide: 0,
  };

  const [isOpenproductImage, setProductImage] = useState(false);
  const [isdisabled, setIsdisabled] = useState(false);

  const handleEditImage = () => {
    setIsdisabled(true);
    url = url[activeIndex];
    removeBackgroundFromImageUrl({
      url,
      apiKey: apikey,
      size: "regular",
      type: "person",
      bg_color: "#ffffff",
    })
      .then((result) => {
        // const base64img = result.base64img;
        handleImageUpdate(url, result.base64img);
      })
      .catch((errors) => {
        setIsdisabled(false);
      });
  };

  const handleImageUpdate = async (img, updatedImage) => {
    try {
      let filename = img.split("/");
      filename = filename[filename.length - 1];
      let payload = {
        productId: data._id,
        previousImgUrl: img,
        currentImgUrl: updatedImage,
        fileName: filename,
      };
      let response = await updateImage(payload);
      if (response.status == 200) {
        setProductImage(false);
        toggle();
        Toast({ type: "success", message: response.data.message });
        handleRefresh();
        setIsdisabled(false);
      }
    } catch (error) {
      setIsdisabled(false);
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalBody>
        <div className={styles.media_container}>
          <div className={styles.media_title} onClick={() => toggle()}>
            <span>PRODUCT MEDIA</span>
          </div>
          <div className={styles.close_media} onClick={() => toggle()}>
            <img src={close} />
          </div>
          <div className="row">
            <div className="col-md-8 col-sm-12 col-12">
              <div className={styles.image_wrapper}>
                <div className="d-flex flex-column">
                  <Swiper {...imageSwiper} className={styles.swiper_image}>
                    {url?.map((list, index) => {
                      return (
                        <SwiperSlide key={index}>
                          <div
                            className={
                              activeIndex == index
                                ? styles.active_img
                                : styles.small_img
                            }
                            onClick={() => {
                              setActiveIndex(index);
                            }}
                          >
                            {fileType(list) == "mp4" ? (
                              <div className={styles.video_media}>
                                <VideoMedia url={list} />
                                <i className="bi bi-play-circle"></i>
                              </div>
                            ) : (
                              <img src={list} alt="" />
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                  {url.length > 4 && (
                    <div className={styles.img_arrow}>
                      <i
                        className={`bi bi-arrow-up-circle ${styles.up}`}
                        id="prevMedia"
                      ></i>
                      <i
                        className={`bi bi-arrow-down-circle ${styles.down}`}
                        id="nextMedia"
                      ></i>
                    </div>
                  )}
                </div>
                <div className={styles.big_img}>
                  {fileType(url[activeIndex]) == "mp4" ? (
                    <VideoPlayer url={url[activeIndex]} />
                  ) : (
                    <>
                      <img src={url[activeIndex]} />
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <button
                className={styles.action_btn}
                onClick={() =>
                  saveAs(url[activeIndex], splitFileName(url[activeIndex]))
                }
              >
                <i className="bi bi-download"></i>
                <span>
                  {fileType(url[activeIndex]) == "mp4"
                    ? "DOWNLOAD VIDEO"
                    : "DOWNLOAD IMAGE"}
                </span>
              </button>
              {showAction && (
                <>
                  <label
                    className={styles.update_img_btn}
                    htmlFor="update-image"
                  >
                    <i className="bi bi-upload"></i>
                    <span>
                      {fileType(url[activeIndex]) == "mp4"
                        ? "CHANGE VIDEO"
                        : "CHANGE IMAGE"}
                    </span>
                  </label>
                  <input
                    type="file"
                    id="update-image"
                    className={styles.update_image}
                    onChange={(e) => onEdit(e, activeIndex)}
                    accept="image/png, image/jpeg, image/jpg, video/mp4"
                  />
                  <button
                    className={styles.action_btn}
                    onClick={() => {
                      onDelete(activeIndex);
                      setActiveIndex(0);
                    }}
                  >
                    <i className="bi bi-trash"></i>
                    <span>
                      {fileType(url[activeIndex]) == "mp4"
                        ? "DELETE VIDEO"
                        : "DELETE IMAGE"}
                    </span>
                  </button>

                  {fileType(url[activeIndex]) !== "mp4" && (
                    <>
                      <button
                        onClick={() => setProductImage(true)}
                        className={styles.edit_button}
                      >
                        <img
                          width="26"
                          src={removebg}
                          alt="remove background"
                        />
                        Remove Background
                      </button>
                    </>
                  )}

                  <label className={styles.add_img_btn} htmlFor="add-image">
                    <i className="bi bi-plus-lg"></i>
                    <span>ADD IMAGE / VIDEO</span>
                  </label>
                  <input
                    type="file"
                    id="add-image"
                    className={styles.add_image}
                    onChange={(e) => onAdd(e)}
                    multiple={true}
                    accept="image/png, image/jpeg, image/jpg, video/mp4"
                  />
                </>
              )}
            </div>
          </div>
        </div>
        <Modal
          centered
          isOpen={isOpenproductImage}
          aria-labelledby="contained-modal-title-vcenter"
          toggle={toggle}
          size="sm"
        >
          <ModalBody>
            <div>
              <p> please comfirm to edit</p>
              <div>
                <label
                  className={styles.add_img_btn}
                  onClick={() => setProductImage(false)}
                >
                  <span>Cancel</span>
                </label>
                <button
                  disabled={isdisabled}
                  className={styles.action_btn}
                  onClick={() => handleEditImage()}
                >
                  Confirm
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </ModalBody>
    </Modal>
  );
};

export default ProductMedia;
